import React from 'react'
import '../../styles/admin/uploads.css'

interface BookInfoCardProps {
  image: React.ReactNode
  title: string
  publisher: string
  price: string
  actions?: React.ReactNode
  purchase?: () => void
}

const BookInfoCard = ({
  image,
  title,
  publisher,
  price,
  actions,
  purchase,
}: BookInfoCardProps) => {
  return (
    <div className="book-info-card">
      <div className="book-image">{image}</div>
      <div className="book-info">
        <div className="book-title">{title}</div>
        <div className="book-publisher">{publisher}</div>
        <div className="book-price">{price}</div>
        <div className="book-actions-container">
          {purchase && (
            <div className="purchase-button" onClick={purchase}>
              Purchase
            </div>
          )}
          {actions && (
            <div className="delete-button" style={{ marginTop: '8px' }}>
              {actions}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default BookInfoCard
